// HARDCODED: maps TC filter titles to the actual values stored on products.
// Entries marked CONFIRMED are verified against real product data.
// Entries marked ASSUMED follow the same naming pattern — verify once sample products are available.
// To be replaced once the backend aligns filter titles with product values.
export const RATING_SYSTEM_TITLE_MAP: Record<string, string> = {
    // CONFIRMED
    'BREEAM Mat 02, EPD':                                                'BREEAM Mat 02, EPD',
    'Green Globes, EPD':                                                 'Green Globes, EPD',
    'LEED v4.1 EPD option 1':                                            'LEED v4.1, EPD option 1',
    'LEED v4.1 Material Ingredients option 1 Material Reporting':        'LEED v4.1 MI option 1, Material reporting',
    'LEED v4.1 Material Ingredients option 2 Material Optimization':     'LEED v4.1 MI option 2, Material optimization',
    'Living Building Challenge, Declare':                                'Living Building Challenge, Declare',
    'WELL v1 97 / v2 (Pilot) X14 Material Transparency':                 'WELL v1 / v2 (Pilot) Material Transparency',
    'WELL v2 X07 Materials Transparency':                                'WELL v2 Materials Transparency',
    'WELL v2 X08 Materials Optimization':                                'WELL v2 Materials Optimization',
    'WELL v1 26 / v2 (Pilot) X13 Enhanced Material Safety/Precaution':   'WELL v1 / v2 (Pilot) Enhanced Material Safety/Precaution',

    // ASSUMED — verify with sample products once available
    'LEED v4.1 EPD option 2 Multi-attribute Optimization':               'LEED v4.1, EPD option 2, Multi-attribute Optimization',
    'LEED v4.1 EPD option 2 Embodied Carbon / LCA Optimization':         'LEED v4.1, EPD option 2, Embodied Carbon / LCA Optimization',
    'LEED v5 Building Product Selection & Procurement (BPSP)':           'LEED v5 MR: BPSP',
};

export const normalizeRating = (s: string) => s.replace(/,/g, '').toLowerCase();
